import React from 'react'

const Rate = () => {
    return (
        <>
            <div className="rate">
                <div >
                    <p className="numbers">1,000+</p>
                    <p>Professionals</p>
                </div>
                <div >
                    <p className="numbers">2,500+</p>
                    <p>Students</p>
                </div>
                <div >
                    <p className="numbers">3,000+</p>
                    <p>
                    Total course views
                    </p>
                </div>
                <div >
                    <p className="numbers">50,000+</p>
                    <p>Student community</p>
                </div>
            </div>
        </>
    )
}

export default Rate
